import { render, staticRenderFns } from "./ModalNotificacaoEmailPreview.vue?vue&type=template&id=58b93db9&scoped=true"
import script from "./ModalNotificacaoEmailPreview.vue?vue&type=script&lang=ts"
export * from "./ModalNotificacaoEmailPreview.vue?vue&type=script&lang=ts"
import style0 from "./ModalNotificacaoEmailPreview.vue?vue&type=style&index=0&id=58b93db9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b93db9",
  null
  
)

export default component.exports